import type { Theme } from '@mui/material/styles'
import theme from '../../../theme'

const styles = {
  invisible: {
    display: {
      xs: 'none',
      md: 'inherit',
    },
    color: 'transparent',
  },
  rootLandscape: {},
  rootPortrait: {
    '--min-height': theme.spacing(21.031),
  },
  root: {
    height: '100%',
    maxHeight: '100%',

    '--image-size': theme.spacing(5.875),

    '& .MuiCard-root, & .MuiCardActionArea-focusHighlight, &:hover, &:focus, &:active, &:focus-visible, &:focus-within, &:visited, &:target':
      {
        width: '100%',
        minHeight: 'var(--min-height)',
        backgroundColor: 'neutral.white',
        boxShadow: 1,
        borderRadius: 0,
        '&:hover': {
          boxShadow: 2,
          backgroundColor: 'neutral.white',
        },
      },

    '& .separator': {
      width: 2,
      height: 2,
      borderRadius: '50%',
      backgroundColor: 'neutral.main',
    },
    '& .light': {
      fontWeight: 300,
    },
  },
  card: {
    height: '100%',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& > div:second-of-type': {
      flexGrow: 2,
    },
  },
  cardInner: {
    p: 'var(--spacing-l)',
    display: 'flex',
    flexDirection: 'row',
    columnGap: 'var(--spacing-l)',
    '& > div:second-of-type': {
      flexGrow: 2,
    },
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'var(--spacing-s)',
  },
  flexRow: {
    display: 'flex',
    gap: 'var(--spacing-m)',
    justifyContent: 'space-between',
  },
  metaInfo: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 'var(--spacing-s)',
    '& p': {
      fontSize: '0.75em',
    },
  },
  category: {
    color: 'neutral.main',
    fontWeight: 700,
  },
  deleteButton: {
    mr: 0.5,
  },
  imagePortrait: {
    width: '100%',
    objectFit: 'cover',
    maxHeight: { xs: '11.479em', md: '19.5em' },
    minHeight: '11.479em',
  },
  imageLandscape: {
    height: {
      xs: 70,
      md: 'var(--image-size)',
    },
    width: {
      xs: 70,
      md: 'var(--image-size)',
    },
    objectFit: 'cover',
  },
  clampedTitle: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
  },
  mediaImage: {
    color: 'neutral.main',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: 0.5,
    height: (theme: Theme) => theme.spacing(0.8),
    '& > img': {
      height: '100%',
      objectFit: 'contain',
    },
  },
}

export default styles
